export namespace ValidationMessages {
  export enum Messages {
    REQUIRE = 'Поле обязательно для заполнения',
    MAX_FILE_SIZE = 'Максимальный допустимый объем файла 10Mb',
    INVALID_FILE_FORMAT = 'Недопустимый формат файла',
    INVALID_EMAIL = 'Введите корректный email',
    INVALID_URL = 'Введите корректное доменное имя сайта',
    INVALID_PHONE_NUMBERS = 'Номер должен состоять из 10 цифр',
    INVALID_PASSWORD_FORMAT = 'Пароль должен сожержать минимум 6 символов: 1 заглавная буква, 1 цифра и 1 символ',
    INVALID_PASSWORD_MATCHING = 'Пароли не совпадают',
    EMAIL_EXISTS = 'Пользователь с таким E-mail уже существует',
    INVALID_VALIDATION_EMAIL_CODE = 'Введен неверный код',
    WRONG_OLD_PASS = 'Неверный старый пароль',
    INVALID_NAME_FORMAT = 'Недопустимый формат имени',
    INVALID_ADDRESS = 'Введите корректный адрес',
    /**
     * для юр. лиц
     */
    WRONG_ORG_INN = 'ИНН должен состоять из 10 цифр',
    WRONG_UNIVERSAL_INN = 'ИНН должен состоять из 12 цифр для ИП и физ. лиц',
    WRONG_KPP = 'КПП должен состоять из 9 цифр',
    MIN_LENGTH = 'Поле должно содержать не менее 2 символов.',
    MIN_LENGTH_3 = 'Поле должно содержать не менее 3 символов.',
    MAX_LENGTH_250 = 'Поле должно содержать не более 250 символов.',
    INVALID_DATE = 'Невалидная дата'
  }

  export const min_error = (count: number) => `Минимальная длина должна быть не менее ${count} символов`;
}

export enum ValidationMasks {
  PHONE = '+7 (###) ###-##-##',

  /**
   * ИНН для физ. лица и ИП
   */
  INN = '############',

  /**
   * ИНН для Юр. лица
   */
  INN_JURIDIC = '##########',

  KPP = '#########',

  /**
   * Почтовый индекс
   */
  ZIP = '######'
}
